import { jsx } from '@vtex/admin-ui-react'

export const Footer = jsx('div')({
  display: 'flex',
  paddingY: 2,
  paddingX: 4,
  borderTop: '$neutral',
  justifyContent: 'space-between',
  bg: 'container',
})
